<shared-list-item-expanded-template>
  <ng-container header-indicators>
    <prescriptions-icon [prescriptionType]="draft().type"></prescriptions-icon>
    @if (quantity()) {
      <div class="flex items-center gap-1 text-sm">
        <mat-icon [fontIcon]="'done_all'"></mat-icon>
        {{ quantity() }}
      </div>
    }
  </ng-container>
  <ng-container header-actions>
    <shared-list-item-neutral-button [matMenuTriggerFor]="draftMenu">
      {{ "buttons.prescription.actionsList" | translate }}
      <mat-icon [fontIcon]="'more_vert'"></mat-icon>
    </shared-list-item-neutral-button>
    <mat-menu #draftMenu="matMenu">
      <button
        mat-menu-item
        (click)="openEditModal()"
      >
        <mat-icon [fontIcon]="'edit'"></mat-icon>
        {{ "prescription.action.edit" | translate }}
      </button>
      <button
        mat-menu-item
        (click)="deleteDraft()"
      >
        <mat-icon [fontIcon]="'delete'"></mat-icon>
        {{ "prescription.action.deleteDraft" | translate }}
      </button>
    </mat-menu>
  </ng-container>
  <div class="relative col-span-7 flex flex-col justify-center gap-2 text-lg">
    <p class="subheader-2">{{ displayName() }}</p>
  </div>
  <div class="col-span-5 flex place-content-end items-center gap-6">
    <div
      class="flex items-center justify-end gap-1 py-1 text-sm"
      [ngClass]="{
        'text-success-600': endDate() > now && startDate() < now,
        'text-warning-600': endDate() < now,
      }"
      [matTooltip]="'prescription.descriptions.period' | translate"
    >
      <mat-icon [fontIcon]="'calendar_month'"></mat-icon>
      <span>{{ formatDate(startDate(), true) }} - {{ formatDate(endDate(), true) }}</span>
    </div>
    @if (draft().guaranteeStatus) {
      <shared-status
        [statusValue]="draft().guaranteeStatus"
        [statusMessage]="'statuses.guarantationStatuses.' + draft().guaranteeStatus | translate"
      ></shared-status>
    }
  </div>
</shared-list-item-expanded-template>
